import { IAdjustmentState } from "../../redux/types/IAdjustmentState";
import { IAdjustment } from "../types/usageTypes/IAdjustment";

export class AdjustmentDetailsMapper {
    public static mapAdjustmentToState(adjustment: IAdjustment): IAdjustmentState {
        if (!adjustment) return null;
        const {
            id,
            adjustmentDate,
            adjustmentCategory,
            adjustmentDistribution,
            adjustmentPool,
            adjustmentSegment,
            adjustmentStatus,
            sourceDistribution,
            sourcePool,
            sourceSegment,
            narrative,
            dataSource,
            versionNumber,
            adjustmentDetails,
            adjustmentBatchID,
            workflows
        } = adjustment

        const state: IAdjustmentState = {
            id,
            adjustmentDate,
            adjustmentCategory,
            adjustmentDistribution,
            adjustmentPool,
            adjustmentSegment,
            adjustmentStatus,
            sourceDistribution,
            sourcePool,
            sourceSegment,
            narrative,
            dataSource,
            versionNumber,
            adjustmentDetails: adjustmentDetails?.map(detail => ({
                ...detail,
                adjustmentDetailTo: detail.adjustmentDetailTo?.map(row => ({ ...row })) ?? []
            })),
            batchId: adjustmentBatchID,
            workflows
        }
        return state;
    }

    public static mapStateToAdjustment(state: IAdjustmentState): IAdjustment {
        if (state) {
            const {
                id,
                adjustmentCategory,
                adjustmentDate,
                adjustmentDistribution,
                adjustmentPool,
                adjustmentSegment,
                adjustmentStatus,
                sourceDistribution,
                sourcePool,
                sourceSegment,
                narrative,
                dataSource,
                versionNumber,
                adjustmentDetails,
                batchId,
                workflows
            } = state;

            const adjustment: IAdjustment = {
                id,
                adjustmentCategory,
                adjustmentDate,
                adjustmentDistribution,
                adjustmentPool,
                adjustmentSegment,
                adjustmentStatus,
                sourceDistribution,
                sourcePool,
                sourceSegment,
                narrative,
                dataSource,
                versionNumber,
                adjustmentDetails,
                adjustmentBatchID: batchId,
                workflows
            }
            return adjustment;
        }
        else return null;
    }
}